import { createFileRoute } from '@tanstack/react-router'
import OrganizationsPage from '@/pages/organizations'

export const Route = createFileRoute('/organizations')({
  component: OrganizationsPage,
})
